import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';
import * as Sentry from '@sentry/browser';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { createStore, applyMiddleware  } from 'redux';
import thunk from 'redux-thunk';
import reducer from './store/reducer';
import { Provider } from 'react-redux';

Sentry.init({dsn: 'https://93915f8bb534401d9695c98fae61efc7@sentry.io/1498390'});

const store = createStore(
  reducer,
  applyMiddleware(thunk)
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
